import React, { useEffect, useState } from 'react';
import { useStore } from '../../../../context/Store';
// import { FlagInterface, Flags } from '../../../../container/store/utils/Flags';
import ButtonBackComponent from '../../../../component/buttton/ButtonBack.component';
import { Title } from '../../../../component/title/Title';
import GridComponent from '../../../../component/grid/GridComponent.component';
import { TableComponent } from './components/table/Table';
import { useSnackbar } from '../../../../context/Snackbar';
import { HeightText } from '../../../../component/heightText/HeightText.component';
import { getCDbtStore } from './utils/STORE_CD';
import { format } from 'date-fns';
import { getSeparations, getDeliveryForecast, getDoca } from './PationManagement.service';
import {ForecastDTO} from './Interface/DeliveryInterface';
import { useManagement } from '../../../../context/Management';
import Loader from '../../../../component/Loader/LoaderComponent';
import { IFlag } from '../../../store/utils/Flags';

const DeliveryForecast = () => {
  const { flag, store, nameStore, arrayFlags } = useStore();
  const { valueCd } = useManagement();
  const { setSnackbar } = useSnackbar();
  const [volume, setVolume] = useState(0);
  const [tableData, setTableData] = useState<ForecastDTO[]>([]);
  const [loading, setLoading] = useState(true)

  const getCurrentWeek = () => {
    let date = new Date();
    let dayOfWeekNumber = date.getDay();
    let nameOfDay;

    switch (dayOfWeekNumber) {
      case 0:
        nameOfDay = 'domingo';
        break;
      case 1:
        nameOfDay = 'segunda';
        break;
      case 2:
        nameOfDay = 'terca';
        break;
      case 3:
        nameOfDay = 'quarta';
        break;
      case 4:
        nameOfDay = 'quinta';
        break;
      case 5:
        nameOfDay = 'sexta';
        break;
      case 6:
        nameOfDay = 'sabado';
        break;
    }

    return nameOfDay;
  }

  const searchSeparations = async () => {
    if (!store || !valueCd) {
      setLoading(false)
      setSnackbar({ type: 'error', msg: 'Loja ou CD não selecionado.', subMsg: 'Por favor selecione uma loja ou CD.' })
    } else {
      try {
        setLoading(true)
        let soma = 0;
        const cds = getCDbtStore(store.toString());
        const doca = await getDoca(valueCd)

        const filterDocaByStore = doca.data.filter((item: any) => item.loja === store)
        const currentDay:any = getCurrentWeek();

        if(filterDocaByStore[0][currentDay] === 1) {
          cds.forEach(async (cd) => {
            const result = (await getSeparations(cd)).data;
            const filterByStore = result.filter((item: any) => item.destino === store)

            filterByStore.forEach((item: any) => {
              soma += item.volumeEstimado
            });
            setVolume(soma)
          })

          var unique:any = []

          const tableRequest:ForecastDTO[] = (await getDeliveryForecast(valueCd, store.toString())).data
          .sort((a:ForecastDTO, b:ForecastDTO) => {
            return Number(new Date(b.created_at)) - Number(new Date(a.created_at))
          })
          .filter((item:ForecastDTO) => item.cd===valueCd && item.destino===store.toString())
          .filter((item:ForecastDTO, index:any, self:any) => {
            const isDuplicate = unique.includes(item.Veiculo)

            if(!isDuplicate) {
              unique.push(item.Veiculo)

              return true
            }

            return false
          })
          .map((item:ForecastDTO) => {
            const data = {
              Veiculo: item.Veiculo,
              StatusVeiculo: item.StatusVeiculo,
              Paletes: item.Paletes,
              DataHoraExpedicao: item.DataHoraExpedicao? item.DataHoraExpedicao : '',
              Iniciar: item.Iniciar ? item.Iniciar : '',
              Finalizar: item.Finalizar ? item.Finalizar : '',
              Edit:( item.Finalizar?.toString() !== '00:00:00' && item.Finalizar !== null) && item.Iniciar?.toString() !== '00:00:00' ? true : false
            }
            return data
          })
          setTableData(tableRequest)
          setLoading(false)
        }
      } catch (e) {
        setLoading(false)
        setSnackbar({ type: 'error', msg: 'Erro.', subMsg: 'Ocorreu um erro, por favor tente novamente mais tarde.' })
      }
    }
  }

  useEffect(() => {
    searchSeparations();
  }, [])

  return (
    <>
      <ButtonBackComponent to="/gestao-de-patio" />
      <GridComponent justify="space-between" alignItems='center' margin="0px 0px 20px 0px">
        <Title fontSize={30} fontWeigth='900'>Previsão de entrega</Title>
        <Title fontSize={25} fontWeigth='700'>{store ? store + ': ' + nameStore + ' -' : ''} {arrayFlags.find((el: IFlag) => el.id === flag)?.flag}</Title>
      </GridComponent>
      {loading ? <Loader /> :
      <>
        <GridComponent justify="space-between" alignItems='center' margin="0px 0px 20px 0px">
          <HeightText>{`Volume estimado de recebimento: ${volume} palete(s)`}</HeightText>
          <HeightText>Data: {format(new Date(), "dd/MM/yyy hh:mm")}</HeightText>
        </GridComponent>
        {tableData.length > 0 && <TableComponent data={tableData}/>}
      </>}
    </>
  )
}

export default DeliveryForecast
